import React from 'react';
import { Helmet } from 'react-helmet';
import { injectIntl } from 'react-intl';

import config from 'config';

const defaultHelmet = (intl) => (
  <Helmet defer={ false }>
    <title>{ intl.formatMessage({ id: 'PatientPortal.PageTab.Title' }) }</title>

    <link rel="shortcut icon" href="/assets/img/favicon/ico/48x48.ico" type="image/x-icon" />
    <link rel="icon" type="image/png" href="/assets/img/favicon/png/16x16.png" sizes="16x16" />
    <link rel="icon" type="image/png" href="/assets/img/favicon/png/32x32.png" sizes="32x32" />
    <link rel="icon" type="image/png" href="/assets/img/favicon/png/96x96.png" sizes="96x96" />
    <link rel="apple-touch-icon" href="/assets/img/favicon/png/57x57.png" />
    <link rel="apple-touch-icon" sizes="57x57" href="/assets/img/favicon/png/57x57.png" />
    <link rel="apple-touch-icon" sizes="72x72" href="/assets/img/favicon/png/72x72.png" />
    <link rel="apple-touch-icon" sizes="76x76" href="/assets/img/favicon/png/76x76.png" />
    <link rel="apple-touch-icon" sizes="114x114" href="/assets/img/favicon/png/114x114.png" />
    <link rel="apple-touch-icon" sizes="120x120" href="/assets/img/favicon/png/120x120.png" />
    <link rel="apple-touch-icon" sizes="144x144" href="/assets/img/favicon/png/144x144.png" />
    <link rel="apple-touch-icon" sizes="152x152" href="/assets/img/favicon/png/152x152.png" />
    <link rel="apple-touch-icon" sizes="180x180" href="/assets/img/favicon/png/180x180.png" />
  </Helmet>
);

const nationalUnionHelmet = (
  <Helmet defer={ false }>
    <title>רופא און־ליין</title>

    <link rel="shortcut icon" href="/assets/img/favicon/ico/48x48.ico" type="image/x-icon" />
    <link rel="icon" type="image/png" href="/assets/img/favicon/png/16x16.png" sizes="16x16" />
    <link rel="icon" type="image/png" href="/assets/img/favicon/png/32x32.png" sizes="32x32" />
    <link rel="icon" type="image/png" href="/assets/img/favicon/png/96x96.png" sizes="96x96" />
  </Helmet>
);

const clalitHelmet = (
  <Helmet defer={ false }>
    <title>Patient Portal</title>

    <link rel="shortcut icon" href="/assets/img/favicon/png/clalit/favicon_96_96.png" type="image/x-icon" />
    <link rel="icon" type="image/png" href="/assets/img/favicon/png/clalit/favicon_16_16.png" sizes="16x16" />
    <link rel="icon" type="image/png" href="/assets/img/favicon/png/clalit/favicon_32_32.png" sizes="32x32" />
    <link rel="icon" type="image/png" href="/assets/img/favicon/png/clalit/favicon_96_96.png" sizes="96x96" />
  </Helmet>
);

const badgerHelmet = (
  <Helmet defer={ false }>
    <title>Patient Portal</title>

    <link rel="shortcut icon" href="/assets/img/favicon/png/badger/favicon_260_260.png" type="image/x-icon" />
  </Helmet>
);

const CurrentHelmet = ({ intl }) => {
  switch (true) {
    case Number(config.org_id):
      return nationalUnionHelmet;
    case config.product_name === 'clalit':
      return clalitHelmet;
    case config.product_name === 'badger':
      return badgerHelmet;
    default:
      return defaultHelmet(intl);
  }
};

export default injectIntl(CurrentHelmet);
